/** Compact single-row height (px). */
export const METRIC_GRID_COMPACT_HEIGHT = 44;
